import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const supportItems = [
  'アカウント運用方針の設計',
  '投稿テーマ・企画案の立案',
  '投稿文案・クリエイティブ制作の支援',
  '運用レポートの作成と改善提案',
];

export default function SnsManagementPage() {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Navbar />

      <main className="flex-1 pt-20">
        <section className="bg-gray-900 py-20 md:py-24">
          <div className="max-w-6xl mx-auto px-6 md:px-10">
            <span className="inline-flex items-center rounded-full border border-yellow-400/50 px-4 py-1.5 text-xs font-bold tracking-widest text-yellow-400 uppercase">
              New Business
            </span>
            <h1 className="mt-5 text-4xl md:text-5xl font-bold leading-tight text-white">
              SNS運用代行
            </h1>
            <p className="mt-5 max-w-3xl text-sm md:text-base leading-relaxed text-gray-300">
              新たに開始したSNS運用代行では、企業や事業の魅力を継続的に伝えるための運用体制づくりを支援します。
              発信方針の整理から投稿設計、改善提案まで一貫して伴走します。
            </p>
          </div>
        </section>

        <section className="py-16 md:py-20">
          <div className="max-w-6xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2 rounded-2xl bg-white border border-gray-100 p-8 md:p-10">
              <h2 className="text-2xl font-bold text-gray-800 mb-5">ご提供内容</h2>
              <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-8">
                情報発信を単発の投稿で終わらせず、継続的な運用として定着させることを重視しています。
                企業の目的や対象顧客に合わせて、実務に落とし込みやすい運用体制をご提案します。
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {supportItems.map((item) => (
                  <div key={item} className="rounded-xl border border-gray-100 bg-gray-50 px-5 py-4">
                    <div className="flex items-start gap-3">
                      <span className="mt-0.5 inline-flex h-6 w-6 items-center justify-center rounded-full bg-yellow-400/20 text-yellow-600">
                        <i className="ri-check-line" />
                      </span>
                      <p className="text-sm font-medium text-gray-700 leading-relaxed">{item}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="rounded-2xl bg-white border border-gray-100 p-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">こんなご相談に対応します</h2>
              <ul className="space-y-3 text-sm leading-relaxed text-gray-600 mb-8">
                <li>発信を始めたいが、何を投稿すべきか整理できていない</li>
                <li>継続的な更新が難しく、運用体制を見直したい</li>
                <li>SNSを活用して認知拡大や導線強化を進めたい</li>
              </ul>

              <Link
                to="/#contact"
                className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-yellow-400 px-5 py-3 text-sm font-semibold text-gray-900 transition hover:bg-yellow-300"
              >
                お問い合わせはこちら
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
